export const CSRF_TOKEN_HEADER = 'X-CSRF-TOKEN';

const CSRF_TOKEN_NAME_META_SELECTOR = 'meta[name="data-csrf-name"]';
const DEFAULT_CSRF_TOKEN_NAME = 'csrf_token';

/**
 * The token PMW.write sends: read from the csrf cookie, or fetched from authenticate/getCsrfData when the cookie is missing.
 */
export const getCsrfToken = async (): Promise<string> => {
  return window.PMW.getCsrfToken((token: string): string => {
    return token;
  });
};

export const getCsrfTokenName = (): string => {
  return document.querySelector<HTMLMetaElement>(CSRF_TOKEN_NAME_META_SELECTOR)?.content ?? DEFAULT_CSRF_TOKEN_NAME;
};
